import { createFileRoute } from "@tanstack/react-router";
// import { PaymentProcess } from "@/components/wallet/PaymentProcess/PaymentProcess.tsx";
import { z } from "zod";
import {WalletSwapWait} from "@/components/wallet/WalletSwapZenex/WalletSwapWait.tsx";

const swapWaitSchema = z.object({
  id: z.string().optional(),
  key: z.string().optional(),
  token: z.string().optional()
});


export const Route = createFileRoute("/_mainLayout/wallet/swap-zenex/wait/")({
  component: RouteComponent,
  validateSearch: swapWaitSchema
});

function RouteComponent() {
  return <WalletSwapWait />;
}
